<div class="modalHeader">
  
</div>

<div class="modalContainer">

       <app-slider
      [allBanners]="allBanners"
      [slideSpeedMs]="700"
      [autoplayIntervalMs]="4000"
      [isRTL]="settings?.appLanguage === 'ar'"
      [loop]="true">
    </app-slider>
</div>

<div class="modalFooter">
<!-- <app-button class="buttonV1 deleteBtnSmall" (buttonClick)="learnMore()" [color]="'white'">
{{"Learn More" | translate}}
</app-button> -->
    <app-button class="buttonV1" (buttonClick)="dismiss()" [color]="'danger'">
        <ion-icon class="appBtnIcon" src="../../../assets/svg/close.svg"></ion-icon>
</app-button>

</div>


